export const BaseURL = `https://api-abot.losyro.com`
// export const BaseURL = `http://127.0.0.1:8000`